












import {Component, Prop, Vue} from 'vue-property-decorator'
import {IBudget} from '@/entities'
import {rangeLabel} from '@/lib'

@Component
export default class TravelBudget extends Vue {
  @Prop() readonly data!: IBudget

  get count(): string {
    let counter = this.data.tourist_count;
    return counter + ' ' + this.$tc('travel.info.travelers', counter);
  }

  get priceRange(): string {
    return rangeLabel(this.data.budget_from, this.data.budget_to, this.$storage.getters.getPriceLabel, {
      between: ' - ',
      minus: this.$options.filters?.capitalize(this.$t('lim-to')) + ' '
    });
  }
}
